/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Dropdown, Loader } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { useAxios } from "~/tools";

type DropdownWithFetchProps = {
  name: string;
  endpoint: string;
  setId: React.Dispatch<React.SetStateAction<string>>;
  dataToFilter?: string[];
};

type Item = {
  id: string;
  name: string;
};

function DropdownWithFetch({
  name,
  endpoint,
  setId,
  dataToFilter = [""],
}: DropdownWithFetchProps) {
  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState([]);
  const [value, setValue] = React.useState("");
  const { showError } = useShowError();
  const { Axios } = useAxios();

  const fetch = React.useCallback(async () => {
    try {
      const { data } = await Axios().get(`/search/${endpoint}`);
      setList(data?.searchResults);
    } catch (e) {
      showError(e.response);
    } finally {
      setIsLoading(false);
    }
  }, [Axios, endpoint, showError]);

  React.useEffect(() => {
    fetch();
  }, [fetch]);

  const listFiltered =
    list
      ?.filter((item: Item) => !dataToFilter.includes(item.id))
      ?.map((r: Item) => ({
        value: r.id,
        label: r.name,
      })) || [];

  return (
    <div>
      {isLoading ? (
        <Loader inContent />
      ) : (
        <>
          <div />
          <Dropdown
            onChange={(s: string) => {
              setValue(s);
              setId(s);
            }}
            value={value}
            name={name}
            options={dataToFilter ? listFiltered : list}
          />
        </>
      )}
    </div>
  );
}

export { DropdownWithFetch };
